import colors from 'styles/colors';
import {
  COMPETITION_COMPLETED_STATUS,
  COMPETITION_ONGOING_STATUS,
  COMPETITION_UPCOMING_STATUS,
} from 'constants/competitions';

const CompetitionHeaderStyles = {
  layout: (thumbnail) => ({
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-end',
    gap: 2,
    padding: '24px',
    height: '280px',
    backgroundImage: thumbnail ? `url(${thumbnail})` : 'none',
    backgroundSize: 'cover',
    mixBlendMode: 'lighten',
    borderRadius: '12px',
  }),
  thumbnailOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '328px',
    background: 'linear-gradient(180deg, rgba(6, 14, 31, 0) 0%, rgba(6, 14, 31, 0.1) 35.33%, rgba(6, 14, 31, 0.75) 55%, rgba(6, 14, 31, 0.95) 100%)',
    zIndex: 1,
    borderRadius: '12px',
  },
  thumbnailContainer: {
    minWidth: '240px',
    width: '240px',
    height: '120px',
    flexShrink: 0,
    borderRadius: '24px',
    overflow: 'hidden',
  },
  content: {
    flex: '1',
    zIndex: 2,
  },
  descriptionStatusContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: 40,
    '@media (max-width: 960px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: '16px',
    },
  },
  title: {
    color: colors.text.primary,
    fontWeight: 'bold',
  },
  actionButton: {
    minWidth: 60,
    width: 100,
    marginBottom: '8px',
    padding: '6px 12px',
  },
  description: {
    color: colors.text.secondary,
    maxHeight: '80px',
    minHeight: '20px',
    overflow: 'auto',
  },
  status: (status, type = 'default') => {
    // Normalize to uppercase to match predefined constants
    const normalizedStatus = status.toUpperCase();

    const statusColors = {
      [COMPETITION_UPCOMING_STATUS]: colors.primary.light,
      [COMPETITION_ONGOING_STATUS]: colors.success.main,
      [COMPETITION_COMPLETED_STATUS]: colors.text.disabled,
    };
    if (type !== 'dot') {
      return {
        color: statusColors[normalizedStatus] || colors.text.secondary,
        fontWeight: 'bold',
        minWidth: '80px',
        textAlign: 'center',
      };
    }
    return {
      backgroundColor: statusColors[normalizedStatus] || colors.text.secondary,
      height: '5px',
      width: '5px',
      borderRadius: '50%',
      display: 'inline-block',
      marginRight: '4px',
      position: 'relative',
      bottom: '2px',
    };
  },

  statusContainer: {
    display: 'flex',
    alignItems: 'center',
    color: colors.text.secondary,
    fontWeight: '600',
    marginRight: '16px',
    minWidth: 'fit-content',
    border: `1px solid ${colors.border.border_10p}`,
    padding: '12px',
    fontSize: '16px',
    lineHeight: '16px',
    borderRadius: '100px',
    background: colors.background.button,
  },
};

export default CompetitionHeaderStyles;
